import { NumberFormat } from 'intl'
import 'intl/locale-data/jsonp/id-ID'

const getPriceCurrency = price => new NumberFormat('id-ID').format(price)

export default getPriceCurrency
